import React, {useEffect, useMemo, useState} from 'react'
import {Modal, OverlayTrigger, Spinner, Tooltip} from 'react-bootstrap'
import {FileUploader} from 'react-drag-drop-files'
import Papa from 'papaparse'
import {read, utils, writeFile, readFile} from 'xlsx'
import {useDispatch, useSelector} from 'react-redux'
import CreatableSelect from 'react-select/creatable'
import MappingSubscriberList from './MappingSubscriberList'
import CopyPastTagAdd from './CopyPastTagAdd'
import {GetData, UpdateByCopyPast} from '../SubscriberSlice/SubscriberSlice'
import {KTSVG} from '../../../../../../_metronic/helpers'
import Dropzone from 'react-dropzone'
import Select, {components, MenuListProps} from 'react-select'
import {getalltagsdata} from '../../Tags/TagSlice/TagsSlices'
import TagPopupModal from './TagPopupModal'
import {ContactOpenPopup} from '../../../../../Components/PopupSlice/popupSlice'
import ReviewModal from './ReviewModal'
import {usePutUploadCustomContactsMutation} from '../../../../../../services/cellcast.v2'
import {toast} from 'react-toastify'
import {AuthenticateUser} from '../../../../../Utils/_helpers/RoleAndPermission'
import { useLazyGetGroupQuery } from '../../../../../../services/cellcast'

const ReSubscribeListPopup = ({show, handleClose, setLoop}: any) => {
  const [next, setNext] = useState(false)
  const groupid: any = useSelector((state: any) => state?.subscriberData?.FieldName?.data?._id)
  const dispatch = useDispatch()
  const [addTags, setAddTags] = useState(false)
  const [mappingPopup, setMappingPopup] = useState(false)
  const [reviewModal, setReviewModal] = useState(false)
  const [checkbox, setCheckbox] = useState(false)
  const [copyPast, setCopyPast] = useState('')
  const [csvdata, setCsvdata] = useState<any>([])
  const [error, setError] = useState({upload: '', copybyNumber: '', copybyDetails: ''})
  const [mapped, setMapped] = useState<any>([])
  const [isAdvancedSettingOpen, setIsAdvancedSettingOpen] = useState<boolean>(false)
  const [finalData, setFinalData] = useState<any>({
    name: '',
    file: '',
    mergeLabels: '',
    tagIds: '',
    unSubList: false,
  })

  const [customData, setCustomData] = useState('')
  const [numberPaste, setNumberPaste] = useState('')
  ////ADD tag related  code
  const tagslist = useSelector((state: any) => state?.tags?.allTags?.data)

  const [openTagPopup, setOpenTagPopup] = useState(false)
  const [tag, setTag] = useState<any>([])
  const [selectedTag, setSelectedTag] = useState<any>([])
  const [checks, setChecks] = useState<any>({})

  const [uploadCustomContactsV2, uploadCustomContactsResult] = usePutUploadCustomContactsMutation()
  const [getGroup] = useLazyGetGroupQuery()

  useEffect(() => {
    let listData = tagslist?.map((val: any) => ({value: val?._id, label: val?.name})) || []
    setTag(listData)
  }, [tagslist])

  const tagHandleChange = async (e: any) => {
    setSelectedTag(e)
  }
  const handleChange = (e: any) => {
    if (
      e[0]?.type == 'text/csv' ||
      e[0]?.type == 'application/vnd.ms-excel' ||
      e[0]?.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ) {
      e[0].arrayBuffer().then((res: any) => {
        let data = new Uint8Array(res)
        let workbook = read(data, {type: 'array'})
        let worksheet = workbook.Sheets[workbook.SheetNames[0]]
        let fdata = utils.sheet_to_csv(worksheet, {rawNumbers: true})
        Papa.parse(fdata, {
          complete: function (results: any) {
            setFinalData({...finalData, name: e?.[0]?.name, file: e[0]})
            setCsvdata(results.data)
            setError({upload: '', copybyDetails: '', copybyNumber: ''})
          },
        })
      })
    }
  }

  const popupClose = () => {
    setNext(false)
    setFinalData({
      name: '',
      file: '',
      mergeLabels: '',
      tagIds: '',
      unSubList: false,
    })
    setError({upload: '', copybyDetails: '', copybyNumber: ''})
    setCustomData('')
    setCopyPast('number')
    setCheckbox(false)
    setAddTags(false)
    setChecks({})
    handleClose()
  }

  const handleDisabled = () => {
    const condition1 = csvdata?.length < 1 && numberPaste == '' && customData == ''
    const condition2 =
      Object.values(checks)?.length == 2 ? !Object.values(checks)?.every((x) => x) : true
    return condition1 || condition2
  }

  const handleSubmit = async () => {
    if (checkbox == false) {
      setMappingPopup(true)
    } else {
      const data = buildCustomContactPayload(true)
      await uploadCustomContactsV2({data, id: groupid}).then((it: any) => {
        setReviewModal(true)
        toast.success(it?.data?.message)
      })
    }
  }

  const buildCustomContactPayload = (validate: boolean = false) => {
    let Findids = tagslist
      ?.map((val: any) => {
        if (Array.isArray(selectedTag)) {
          if (selectedTag?.find((key: any) => key?.label == val?.name) !== undefined) {
            return val?._id
          }
        } else {
          if (selectedTag?.label == val?.name) {
            return val?._id
          }
        }
      })
      ?.filter((key: any) => key !== undefined)

    const values: any = {
      uploadData: numberPaste,
      type: 'only-number',
      tagIds: JSON.stringify(Findids),
      campaignUpload: false,
      unSubList: finalData?.unSubList,
      validate,
      resubscribe: true,
    }
    const val: any = {
      uploadData: customData,
      type: 'custom-fields',
      tagIds: JSON.stringify(Findids),
      campaignUpload: false,
      unSubList: finalData?.unSubList,
      validate,
      resubscribe: true,
    }
    const FinalData2 = new FormData()
    const FinalData = new FormData()
    for (var key in values) {
      FinalData.append(key, values[key])
    }
    for (var key in val) {
      FinalData2.append(key, val[key])
    }

    if (copyPast == 'number') {
      return FinalData
    }

    return FinalData2
  }

  const handleUploadCustomContact = () => {
    const data = buildCustomContactPayload()

    uploadCustomContactsV2({data, id: groupid})
      .then((res: any) => {
        setReviewModal(false)
        dispatch(ContactOpenPopup())
        popupClose()
        toast.success(res?.data?.message)
      })
      .catch((e) => {
        toast.error(e?.data?.message)
      })
      .finally(() => {
        getGroup(null)
      })
  }

  useEffect(() => {
    dispatch(GetData())
  }, [])

  const AddTagPopup = useMemo(
    () => (
      <TagPopupModal
        selectedTag={selectedTag}
        setSelectedTag={setSelectedTag}
        show={openTagPopup}
        handleClose={() => {
          setOpenTagPopup(false)
        }}
      />
    ),
    [openTagPopup]
  )
  const acceptedFileTypes = {
    'text/csv': ['.csv'],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx', '.xls'],
  }

  const MenuList = (props: MenuListProps<any>) => {
    return (
      <components.MenuList {...props}>
        {props.children}
        <OverlayTrigger
          placement='top'
          overlay={<Tooltip id='button-tooltip'>Create new tag</Tooltip>}
        >
          <div
            className='select-create-button'
            onClick={() => {
              setOpenTagPopup(true)
            }}
          >
            <i className='bi bi-plus-lg'></i>
            <p>Create new</p>
          </div>
        </OverlayTrigger>
      </components.MenuList>
    )
  }

  const reviewModalPopup = useMemo(
    () => (
      <ReviewModal
        show={reviewModal}
        handleClose={() => setReviewModal(false)}
        handleSubmit={handleUploadCustomContact}
        report={uploadCustomContactsResult}
      />
    ),
    [reviewModal, uploadCustomContactsResult?.isLoading]
  )

  return (
    <>
      {AddTagPopup}
      {reviewModalPopup}

      <MappingSubscriberList
        setSelectedTag={setSelectedTag}
        selectedTag={selectedTag}
        closeUpload={popupClose}
        finalData={finalData}
        setFinalData={setFinalData}
        data={csvdata}
        mapped={mapped}
        setMapped={setMapped}
        show={mappingPopup}
        handleClose={() => setMappingPopup(false)}
        setCheckbox={setCheckbox}
        setCsvdata={setCsvdata}
        resubscribe={true}
      />

      <Modal
        id='kt_modal_create_app'
        tabIndex={1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-700px'
        className='vh-100'
        show={show}
        onHide={() => {
          popupClose()
        }}
      >
        {AuthenticateUser('edit-contact') && (
          <div className='modal-header'>
            <h1>Resubscribe Contacts</h1>
            <div
              className='btn btn-icon btn-sm'
              onClick={() => {
                popupClose()
              }}
            >
              <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
            </div>
          </div>
        )}
        <div className='modal-body p-15'>
          <div className='row'>
            <div className='fv-row mb-5'>
              <div className='form-check form-check-custom form-check-solid'>
                <input
                  className='form-check-input mb-6'
                  type='radio'
                  value=''
                  id='flexRadioChecked6'
                  checked={!checkbox}
                  onChange={() => {
                    setCheckbox(false)
                    setCustomData('')
                    setNumberPaste('')
                  }}
                />
                <label
                  className='form-check-label align-items-start flex-column d-flex ms-3'
                  htmlFor='flexRadioChecked6'
                >
                  <span className='card-label fw-bolder fs-5'>Import new list</span>
                  <span className='text-muted fs-7'>
                    Upload a new list from a file, Acceptable file Types: Comma Seprated CSV or text
                    files.{' '}
                    <a href='https://cellcast-profile-image.s3.ap-southeast-2.amazonaws.com/utils/sample_contacts.csv'>
                      Download example CSV
                    </a>
                  </span>
                  {!checkbox && (
                    <>
                      {finalData?.name !== '' ? (
                        <>
                          <section className='dragAndDrop'>
                            <div className='removeFile'>
                              <span className='fs-10'> {finalData?.name}</span>
                              <KTSVG
                                onClick={() => {
                                  setCsvdata([])
                                  setFinalData({
                                    name: '',
                                    file: '',
                                    mergeLabels: '',
                                    tagIds: '',
                                    unSubList: false,
                                  })
                                }}
                                path='/media/misc/cross-square.svg'
                                className='svg-icon  reomveIcon'
                              />
                            </div>
                          </section>
                        </>
                      ) : (
                        <Dropzone onDrop={handleChange} accept={acceptedFileTypes}>
                          {({getRootProps, getInputProps}) => (
                            <section className='dragAndDrop'>
                              <KTSVG
                                path={'/media/svg/dragandDrop.svg'}
                                className='svg-icon-3x me-3'
                              />
                              <div {...getRootProps()}>
                                <input {...getInputProps()} />
                                <span className='fs-7 d-block fw-boldest'>
                                  Drop files here or click to upload
                                </span>
                                <span className='text-muted fs-7'>csv,xlsx</span>
                              </div>
                            </section>
                          )}
                        </Dropzone>
                      )}
                    </>
                  )}
                </label>
              </div>
            </div>
            <span className='ps-12'>{finalData?.name}</span>

            {error.upload !== '' && <span className='text-danger mx-10 mb-10'>{error.upload}</span>}
            <div className='fv-row mb-10 mt-5'>
              <div className='form-check form-check-custom form-check-solid'>
                <input
                  className='form-check-input mb-6'
                  type='radio'
                  value=''
                  id='flexRadioChecked'
                  checked={checkbox}
                  onChange={() => {
                    setCheckbox(true)
                    setCsvdata([])
                    setCopyPast('')
                    setFinalData({
                      name: '',
                      file: '',
                      mergeLabels: '',
                      tagIds: '',
                      unSubList: false,
                    })
                  }}
                />
                <label
                  className='form-check-label align-items-start flex-column d-flex ms-3'
                  htmlFor='flexRadioChecked'
                >
                  <span className='card-label fw-bolder fs-5'>Copy and Paste list</span>
                  <span className='text-muted fs-7'>
                    Paste your client data in without creating a list. Follow format and sequence as
                    outlined below, each subscriber to fall on a new line.
                  </span>
                </label>
              </div>
              {checkbox && (
                <>
                  <div className='form-check form-check-custom form-check-sm form-check-solid ms-10 mt-3'>
                    <div className='row w-100'>
                      <div className=' w-100 d-flex  align-items-center justify-content-between mb-3'>
                        <div className='row w-100'>
                          <input
                            className='form-check-input mb-3 col-2 margin-remove'
                            type='radio'
                            value=''
                            id='flexRadioChecked1'
                            style={{
                              margin: '0px !important',
                            }}
                            checked={copyPast == 'number'}
                            onChange={() => setCopyPast('number')}
                          />
                          <label
                            className='form-check-label align-items-start flex-column d-flex ms-0 col-6'
                            htmlFor='flexRadioChecked1'
                          >
                            <span className='card-label fw-bold fs-5'>Number Only</span>
                          </label>
                        </div>
                        <div className='row w-100'>
                          <input
                            className='form-check-input mb-6 col-2 margin-remove'
                            type='radio'
                            value=''
                            id='flexRadioChecked2'
                            checked={copyPast == ''}
                            style={{
                              margin: '0px !important',
                            }}
                            onChange={() => setCopyPast('')}
                          />
                          <label
                            className='form-check-label align-items-start flex-column d-flex ms-0 col-8'
                            htmlFor='flexRadioChecked2'
                          >
                            <span className='card-label fw-bold fs-5'>Custom details</span>
                          </label>
                        </div>
                      </div>
                      {copyPast == 'number' ? (
                        <>
                          <textarea
                            onBlur={() => {
                              numberPaste.trim() == '' &&
                                setError({...error, copybyNumber: 'Please insert data'})
                            }}
                            onChange={(e: any) => {
                              setNumberPaste(e.target.value)
                              setError({...error, copybyNumber: '', upload: ''})
                            }}
                            className='form-control form-control-lg form-control-solid'
                            placeholder='Eg: Number, Number, Number, Number, Number, Number, Number'
                            rows={4}
                          />
                          {error.copybyNumber !== '' && (
                            <span className='text-danger mt-2'>{error.copybyNumber}</span>
                          )}
                        </>
                      ) : (
                        <>
                          <textarea
                            onBlur={() => {
                              customData.trim() == '' &&
                                setError({...error, copybyDetails: 'Please insert data'})
                            }}
                            onChange={(e: any) => {
                              setCustomData(e.target.value)
                              setError({copybyDetails: '', upload: '', copybyNumber: ''})
                            }}
                            className='form-control form-control-lg form-control-solid'
                            placeholder='Eg: Number, First Name, Last Name, Gender, Postal Code, Date of Birth, Special Field, Custom Field1, Custom Field2, Custom Field3'
                            rows={4}
                          />
                          <span className='text-danger mt-3 gray-muted'>
                            Ensure each contact falls on separate lines, with the following format:
                            Number, First Name, Last Name, Gender, Postal Code, Date of Birth,
                            Custom Field 1
                          </span>

                          {error.copybyDetails !== '' && (
                            <span className='text-danger mt-2'>{error.copybyDetails}</span>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>

          {/* Advance seeting */}
          <div className='advance_setting mb-7'>
            <h4
              className='cursor-pointer'
              onClick={() => {
                setIsAdvancedSettingOpen(!isAdvancedSettingOpen)
              }}
            >
              {isAdvancedSettingOpen ? (
                <KTSVG
                  path='/media/icons/duotune/arrows/arrow-right.svg'
                  className='svg-icon-6 me-2'
                  style={{
                    transform: 'rotate(90deg)',
                    transition: 'all .5s ease-in-out',
                  }}
                />
              ) : (
                <KTSVG
                  path='/media/icons/duotune/arrows/arrow-right.svg'
                  className='svg-icon-6 me-2'
                  style={{
                    transform: 'rotate(0deg)',
                    transition: 'all .5s ease-in-out',
                  }}
                />
              )}
              Advanced settings
            </h4>
            {isAdvancedSettingOpen ? (
              <>
                <div className='form-check form-check-sm form-check-custom form-check-solid ps-7'>
                  <input
                    onChange={() => {
                      setAddTags(!addTags)
                      setSelectedTag([])
                    }}
                    className='form-check-input me-5'
                    id='contact'
                    type='checkbox'
                    data-kt-check='true'
                    checked={addTags}
                  />
                  <div>
                    <label htmlFor='contact' style={{lineHeight: '0.65'}}>
                      Add tag to new contacts (optional)
                      <span className='ms-2'>
                        <svg
                          width='16'
                          height='16'
                          viewBox='0 0 16 16'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            opacity='0.3'
                            d='M8 15.5C12.1421 15.5 15.5 12.1421 15.5 8C15.5 3.85786 12.1421 0.5 8 0.5C3.85786 0.5 0.5 3.85786 0.5 8C0.5 12.1421 3.85786 15.5 8 15.5Z'
                            fill='#838492'
                          />
                          <path
                            d='M8 10.2497C7.85081 10.2497 7.70774 10.1904 7.60225 10.0849C7.49676 9.97945 7.4375 9.83638 7.4375 9.68719V9.07219C7.4305 8.69625 7.52949 8.32593 7.72314 8.00362C7.9168 7.68131 8.19728 7.42003 8.5325 7.24969C8.72899 7.15461 8.89643 7.00865 9.01744 6.82698C9.13845 6.64531 9.20862 6.43455 9.22064 6.2166C9.23266 5.99864 9.18611 5.78144 9.08581 5.58756C8.98552 5.39368 8.83514 5.23019 8.6503 5.11408C8.46546 4.99796 8.25291 4.93345 8.03471 4.92725C7.81651 4.92106 7.60063 4.97339 7.4095 5.07883C7.21837 5.18427 7.05895 5.33895 6.94781 5.52683C6.83667 5.7147 6.77787 5.92891 6.7775 6.14719C6.7775 6.29638 6.71823 6.43945 6.61274 6.54494C6.50726 6.65043 6.36418 6.70969 6.215 6.70969C6.06581 6.70969 5.92274 6.65043 5.81725 6.54494C5.71176 6.43945 5.6525 6.29638 5.6525 6.14719C5.65375 5.80373 5.73012 5.46469 5.87624 5.15386C6.02237 4.84303 6.23472 4.56792 6.4984 4.34783C6.76208 4.12773 7.07072 3.96798 7.40267 3.87977C7.73461 3.79156 8.08184 3.77703 8.42 3.83719C8.89211 3.92601 9.32594 4.15664 9.66361 4.49834C10.0013 4.84004 10.2268 5.27656 10.31 5.74969C10.4046 6.25535 10.3294 6.7781 10.0961 7.23658C9.8628 7.69506 9.48447 8.06355 9.02 8.28469C8.87783 8.36211 8.75985 8.47735 8.6791 8.61766C8.59836 8.75796 8.558 8.91787 8.5625 9.07969V9.69469C8.56052 9.84257 8.50039 9.98373 8.39512 10.0876C8.28984 10.1915 8.14789 10.2497 8 10.2497Z'
                            fill='#838492'
                          />
                          <path
                            d='M7.99999 12.1924C8.31065 12.1924 8.56249 11.9405 8.56249 11.6299C8.56249 11.3192 8.31065 11.0674 7.99999 11.0674C7.68933 11.0674 7.43749 11.3192 7.43749 11.6299C7.43749 11.9405 7.68933 12.1924 7.99999 12.1924Z'
                            fill='#7950F2'
                          />
                        </svg>
                      </span>
                    </label>
                    <p>Tagging your customers helps better identify them and create segments</p>

                    {addTags && (
                      <Select
                        value={selectedTag}
                        components={{MenuList}}
                        classNamePrefix='createBox'
                        isMulti
                        options={tag}
                        className='selectbox-create-custom'
                        onChange={tagHandleChange}
                      />
                    )}
                  </div>
                </div>
              </>
            ) : null}
          </div>
          <hr className='hr' style={{backgroundColor: '#e3e3e3', height: '2px'}}></hr>
          <div className='form-check form-check-sm form-check-custom form-check-solid'>
            <input
              onChange={(e: any) => {
                setChecks({...checks, first: e.target.checked})
              }}
              checked={checks?.first}
              className='form-check-input me-3'
              id='first'
              type='checkbox'
              data-kt-check='true'
            />
            <div>
              <label htmlFor='first' style={{lineHeight: '1.65'}}>
                This persons have given me permission to message them.
              </label>
            </div>
          </div>
          <div className='form-check form-check-sm form-check-custom form-check-solid mt-4'>
            <input
              onChange={(e: any) => {
                setChecks({...checks, second: e.target.checked})
              }}
              checked={checks?.second}
              className='form-check-input me-3'
              id='second'
              type='checkbox'
              data-kt-check='true'
            />
            <div>
              <label htmlFor='second' style={{lineHeight: '1.65'}}>
                Are you sure you want to subscribe all selected contacts? This action will change
                the status of any contacts currently unsubscribed to subscribed, and they will be
                able to receive messages from you
              </label>
            </div>
          </div>
          <div className='d-flex justify-content-end mt-5'>
            <div id='kt_drawer_chat_close'>
              <button
                type='button'
                onClick={() => {
                  popupClose()
                }}
                className='btn btn-sm gray_bg_purple me-2 w-100px p-3 fw-500 me-2'
              >
                Cancel
              </button>
            </div>
            <button
              className='btn btn-sm btn-light btn-primary fw-500   w-100px p-3 border-primary'
              disabled={handleDisabled()}
              onClick={handleSubmit}
            >
              <span className='indicator-label'>Submit</span>
            </button>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default ReSubscribeListPopup
